import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import MotiveLogo from 'assets/logos/motive-logo.svg'
import Project44Logo from 'assets/logos/project44-small-logo.png'
import EditIcon from 'transfix-icons/build/EditIcon'
import SuccessIcon from 'transfix-icons/build/SuccessIcon'
import { IconButton } from 'transfix-ui/components/IconButton'
import { Box, Typography } from 'transfix-ui/core'
import { selectEldTracking, isEldTrackingSubmitSuccess } from 'utils/reducers/carrier'
import { ELD_STATUS } from 'apps/carrier/constants/carrierProfile'
import { clearEldTracking } from 'apps/carrier/utils/actions/carrierInfo'
import { Card, CardHeader, Toast, RelativeDateTime } from 'transfix-ui'
import { useModal } from 'utils/hooks'
import TrackingLocationModal from './TrackingLocationModal'
import { useTrackingLocationStyles } from './useTrackingLocationStyles'

export function TrackingLocation() {
  const dispatch = useDispatch()
  const { closeModal, isOpen, openModal } = useModal()
  const {
    eldTrackingMethod,
    isEldApproved,
    isEldApprovedUpdatedAt,
    keepTruckinEnabled,
    keepTruckinEnabledUpdatedAt,
  } = useSelector(selectEldTracking)
  const classes = useTrackingLocationStyles()
  const isSubmitSuccess = useSelector(isEldTrackingSubmitSuccess)
  const closeToastHandler = () => dispatch(clearEldTracking())

  const setShowModal = (open: boolean) => (open ? openModal('tracking')() : closeModal())

  return (
    <Card dataTest='tracking-location'>
      <CardHeader
        actionButton={
          <IconButton
            Icon={EditIcon}
            color='tertiary'
            onClick={() => {
              setShowModal(true)
            }}
            data-test='edit-project44'
            label='Edit Tracking Capabilities'
            size='large'
            className='icon-btn-project44'
          />
        }>
        <Typography variant='h3'>Tracking Capabilities</Typography>
      </CardHeader>
      <div>
        <div className={classes.subContent}>
          <img className={classes.trackingLogo} src={Project44Logo} alt='' />
          <span className={classes.textBold}>Project44</span>
        </div>
        {isEldApprovedUpdatedAt && (
          <div data-test='project44-updates'>
            {eldTrackingMethod && (
              <Box display='flex' flexDirection='row' alignItems='center'>
                <SuccessIcon color='green2' size='medium' className={classes.succesIconMargin} />
                <Typography variant='body1'>{ELD_STATUS[eldTrackingMethod]}</Typography>
              </Box>
            )}
            <span className={classes.textSmall}>
              Last updated{' '}
              <RelativeDateTime datetime={isEldApprovedUpdatedAt} inSentence isShorthand />
            </span>
          </div>
        )}
        <div className={classes.status}>
          <span className={classes.textSecondary}>Onboarded and Approved:</span>{' '}
          <span data-test='project44-approved'>{isEldApproved ? 'Yes' : 'No'}</span>
        </div>
      </div>
      <div>
        <hr className={classes.separator} />
        <div className={classes.subContent}>
          <img className={classes.trackingLogo} src={MotiveLogo} alt='' />
          <span className={classes.textBold}>Motive</span>
        </div>
        {keepTruckinEnabled && (
          <div>
            <Box display='flex' flexDirection='row' alignItems='center'>
              <SuccessIcon color='green2' size='medium' className={classes.succesIconMargin} />
              <Typography variant='body1'>This carrier is connected to Motive</Typography>
            </Box>
            {keepTruckinEnabledUpdatedAt && (
              <span className={classes.textSmall}>
                Last updated{' '}
                <RelativeDateTime datetime={keepTruckinEnabledUpdatedAt} inSentence isShorthand />
              </span>
            )}
          </div>
        )}
        {!keepTruckinEnabled && <Box className={classes.textSecondary}>Not connected</Box>}
      </div>
      <TrackingLocationModal showModal={isOpen('tracking')} setShowModal={setShowModal} />
      <Toast message='Changes Saved' open={isSubmitSuccess || false} onClose={closeToastHandler} />
    </Card>
  )
}
